function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import * as RadixCollapsible from "@radix-ui/react-collapsible";
import { cva } from "class-variance-authority";
import { Divider } from "../Divider/index.js";
import { Icon } from "../Icon/index.js";
import { Link } from "../Link/index.js";
import { Typography } from "../Typography/index.js";
import { cn } from "../../common/helpers.js";
const toggleIconClasses = cva([
    'transition',
    'duration-200',
    'text-primary',
    'group-data-[state=open]:-rotate-180'
]);
const contentClasses = cva([
    'data-[state=closed]:animate-collapsible-close',
    'data-[state=open]:animate-collapsible-open',
    'overflow-hidden'
]);
function CardAccordionCollapsible(props) {
    const { children, title, slots = {}, slotProps = {}, className } = props, rest = _object_without_properties(props, [
        "children",
        "title",
        "slots",
        "slotProps",
        "className"
    ]);
    var _slots_collapsibleContainer;
    const CollapsibleContainer = (_slots_collapsibleContainer = slots.collapsibleContainer) !== null && _slots_collapsibleContainer !== void 0 ? _slots_collapsibleContainer : slotProps.collapsibleContainer ? 'div' : Fragment;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mx-6",
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                className: "mb-0 mt-5"
            }),
            /*#__PURE__*/ _jsxs(RadixCollapsible.Root, _object_spread_props(_object_spread({}, rest), {
                className: cn('mt-5', className),
                children: [
                    /*#__PURE__*/ _jsx(CollapsibleContainer, _object_spread_props(_object_spread({}, slotProps.collapsibleContainer), {
                        children: /*#__PURE__*/ _jsxs(RadixCollapsible.Trigger, {
                            className: "flex flex-row w-full items-center gap-x-[6px] outline-primary outline-offset-2 group",
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    as: "p",
                                    noUnderline: true,
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Icon, {
                                    icon: "chevron-down",
                                    className: toggleIconClasses()
                                })
                            ]
                        })
                    })),
                    /*#__PURE__*/ _jsx(RadixCollapsible.Content, {
                        className: contentClasses(),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            as: "div",
                            className: "scl-rich-text mt-4 break-words",
                            children: children
                        })
                    })
                ]
            }))
        ]
    });
}
export default CardAccordionCollapsible;
